export default class IdentityLoginState {
    public static IsResetPassword: boolean = true;
    public static IsLoginShow: boolean = false;

}